<!-- @format -->
<div
	id="krakenContent"
	*ngIf="krakenContent"
	homeUtilsAppRunScripts
	[attr.data-sectionnum]="addlData.tagSectionNum"
	[innerHTML]="krakenContent | dcsgSanitizeHtml"></div>
